document.querySelectorAll('.schema-faq-answer').forEach((answer) => {
  const inner = document.createElement('div');
  while (answer.firstChild) inner.appendChild(answer.firstChild);
  answer.appendChild(inner);
});

document.querySelectorAll('.schema-faq-question').forEach((question) => {
  question.addEventListener('click', () => {
    const section = question.closest('.schema-faq-section');
    section.classList.toggle('is-open');
  });
});
